import React from "react"
import ClientChip from "../../molecules/ClientChip.molecule"
import ProjectChip from "../../molecules/ProjectChip.molecule"
import InlineMultiSelectDropdown from "../../molecules/InlineMultiSelectDropdown.molecule"

const clientFilterTemplate = ({
  options,
  projects,
  clientFilterOptionsRef,
  loading,
}) => {
  clientFilterOptionsRef.current = options
  return (
    <InlineMultiSelectDropdown
      className="client-project-multiselect"
      panelClassName="max-w-23rem"
      value={options.value ?? []}
      options={projects}
      onChange={(value) => {
        options.filterCallback(value.length ? value : undefined)
      }}
      optionLabel="name"
      optionValue="name"
      placeholder="Todos"
      optionGroupLabel="name"
      optionGroupChildren="items"
      optionGroupTemplate={(option) => {
        if (option.type === "client") {
          return <ClientChip clientCode={option.code} />
        }
      }}
      hideToggleButton
      initiallyExpanded
      itemTemplate={(option) => {
        return (
          <div className="project-item-template flex align-items-center gap-2">
            <ProjectChip
              clientCode={option.clientCode}
              projectCode={option.code}
            />
            <span className="overflow-hidden white-space-nowrap text-overflow-ellipsis">
              {option.name}
            </span>
          </div>
        )
      }}
      loading={loading}
      disabled={projects.length === 0}
    />
  )
}

export default clientFilterTemplate
